import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Cancelar from './views/Cancelar.vue'
import Invalido from './views/Invalido.vue'
import Finalizado from './views/Finalizado.vue'
import AdmissaoForm from './views/AdmissaoForm.vue'
import ContratoForm from './views/ContratoForm.vue'
import ContratoEPIForm from './views/ContratoEPIForm.vue'
import ContratoInvalido from './views/ContratoInvalido.vue'
import ContratoAssinado from './views/ContratoAssinado.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/cancelar',
      name: 'cancelar',
      component: Cancelar
    },
    {
      path: '/invalido',
      name: 'invalido',
      component: Invalido
    },
    {
      path: '/finalizado',
      name: 'finalizado',
      component: Finalizado
    },
    {
      path: '/formulario/:uid',
      name: 'formulario',
      component: AdmissaoForm
    },
    {
      path: '/contrato/invalido',
      name: 'contrato_invalido',
      component: ContratoInvalido
    },
    {
      path: '/contrato/finalizado',
      name: 'contrato_finalizado',
      component: ContratoAssinado
    },
    {
      path: '/contrato/:uid',
      name: 'contrato',
      component: ContratoForm
    },
    {
      path: '/contrato-epi/:uid',
      name: 'contrato_epi',
      component: ContratoEPIForm
    }
    // {
    //  path: '/about',
    //  name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
